import { Component, ElementRef, ViewChild } from '@angular/core';
import { LiveAgentSupportService } from '../../header/live-agent-support/live-agent-support.service';
import { TranslationService } from '../../shared/translation.service';
import { ResetPasswordResponse } from '../../shared/types/ResetPasswordDto';
import { LoginService } from '../login.service';

@Component({
  selector: 'lp2-recovery-box',
  templateUrl: './recovery-box.component.html',
  styleUrls: ['./recovery-box.component.scss']
})
export class RecoveryBoxComponent {
  isLoading: boolean;
  email: string;
  resetSuccess: boolean;
  submitted: boolean;
  @ViewChild('chatOnline') chatOnline: ElementRef;
  constructor(
    private loginService: LoginService,
    private liveAgentSupportService: LiveAgentSupportService,
    private translationService: TranslationService,
  ) {}

  enterLiveChat() {
    this.liveAgentSupportService.startChat();
  }

  resetPassword() {
    this.isLoading = true;
    this.submitted = false;
    this.loginService.resetPasswordWithEmail(this.email)
    .subscribe((res) => {
      this.isLoading = false;
      this.submitted = true;
      switch (res.response) {
        case ResetPasswordResponse.OK:
          this.resetSuccess = true;
          break;
        default:
          this.resetSuccess = false;
          break;
      }
    }, (error) => {
      console.error(error);
      this.isLoading = false;
      this.resetSuccess = false;
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/recovery-box/recovery-box.component.ts